import { match } from '../utils/match';

const splitActionChoices = (types) => {
    const getActions = (joinedTypes, handler) => joinedTypes.split(',').reduce((split, type) => ({
        ...split,
        [type]: handler,
    }), {});

    return Object.keys(types).reduce((split, type) => ({
        ...split,
        ...getActions(type, types[type]),
    }), {});
};

export const createMiddleware = (types, options = {}) => store => next => (action) => {
    const splitTypes = splitActionChoices(types);
    let nextAction;

    if (!options.beforeChanges) {
        nextAction = typeof next === 'function' ? next(action) : action;
    }

    const call = match(() => action.type, splitTypes);
    const result = call(store.getState(), action);
    if (result) {
        const dispatch = (actionsOrNull) => {
            const actions = Array.isArray(actionsOrNull) ? actionsOrNull : [actionsOrNull];
            actions.filter(Boolean).forEach(currentAction => store.dispatch(currentAction));
        };

        Promise.resolve(result).then(dispatch);
    }

    if (options.beforeChanges) {
        nextAction = typeof next === 'function' ? next(action) : action;
    }

    return nextAction;
};
